import {AfterViewInit, Directive, ElementRef, Input} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/pairwise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/exhaustMap';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/startWith';
import { of } from 'rxjs/observable/of';

interface ScrollPosition {
  sH: number;
  sT: number;
  cH: number;
}

const DEFAULT_SCROLL_POSITION: ScrollPosition = {
  sH: 0,
  sT: 0,
  cH: 0
};

@Directive({
  selector: '[chatScroller]'
})
export class ChatScrollerDirective implements AfterViewInit {

  private scrollEvent$;

  private userScrolledUp$;

  private requestOnScroll$;

  @Input()
  scrollCallback;

  @Input()
  handleScrollDataCallback;

  @Input()
  immediateCallback;

  @Input()
  scrollPercent = 10;

  constructor(private elm: ElementRef) { }

  ngAfterViewInit() {

    this.registerScrollEvent();

    this.streamScrollEvents();

    this.requestCallbackOnScroll();

  }

  private registerScrollEvent() {

    this.scrollEvent$ = Observable.fromEvent(this.elm.nativeElement, 'scroll').debounceTime(200);

  }

  private streamScrollEvents() {
    this.userScrolledUp$ = this.scrollEvent$
      .map((e: any): ScrollPosition => ({
        sH: e.target.scrollHeight,
        sT: e.target.scrollTop,
        cH: e.target.clientHeight
      }))
      .pairwise()
      .filter(positions => this.isUserScrollingUp(positions) && this.isScrollExpectedPercent(positions[1]));
  }

  private requestCallbackOnScroll() {

    this.requestOnScroll$ = this.userScrolledUp$;

    if (this.immediateCallback) {
      this.requestOnScroll$ = this.requestOnScroll$
        .startWith([DEFAULT_SCROLL_POSITION, DEFAULT_SCROLL_POSITION]);
    }

    this.requestOnScroll$
      .exhaustMap(() => {
        const next = this.scrollCallback();
        return next || of(null);
      })
      .subscribe((res) => {
        if (!res) { return; }

        this.handleScrollDataCallback(res);
      });

  }

  private isUserScrollingUp = (positions) => {
    return positions[0].sT > positions[1].sT;
  }

  private isScrollExpectedPercent = (position) => {
    const scrollUpPercent = position.sT / (position.sH - position.cH);
    return scrollUpPercent < (this.scrollPercent / 100);
  }

}



// WEBPACK FOOTER //
// ./src/app/directive/chat-scroller-directive.ts